import { invokeVendorCallable, requireOrganizationId } from "@core/data/callable";

export async function listNotifications(organizationId) {
  const data = await invokeVendorCallable("vendorsListNotifications", { organizationId: requireOrganizationId(organizationId) });
  return { notifications: Array.isArray(data.notifications) ? data.notifications : [], unreadCount: Number(data.unreadCount) || 0 };
}

export async function markNotificationRead(organizationId, notificationId, read = true) {
  const data = await invokeVendorCallable("vendorsMarkNotificationRead", { organizationId: requireOrganizationId(organizationId), notificationId, read });
  return data.notification;
}

export async function markAllNotificationsRead(organizationId) {
  const data = await invokeVendorCallable("vendorsMarkAllNotificationsRead", { organizationId: requireOrganizationId(organizationId) });
  return Number(data.updatedCount) || 0;
}

export async function getNotificationPreferences(organizationId) {
  const data = await invokeVendorCallable("vendorsGetNotificationPreferences", { organizationId: requireOrganizationId(organizationId) });
  return data.preferences;
}

export async function updateNotificationPreferences(organizationId, preferences) {
  const data = await invokeVendorCallable("vendorsUpdateNotificationPreferences", { organizationId: requireOrganizationId(organizationId), preferences });
  return data.preferences;
}
